import { Outlet, useParams } from 'react-router-dom';
import NavBar from '../ui/NavBar';
import MemooryNavTabs from './MemooryNavTabs';
import Footer from '@/components/ui/Footer';
import useAuth from '../Auth/useAuth';
import { queryClient } from '@/App';
import { getTopics } from '@/api/topic';
import { useQuery } from '@tanstack/react-query';
import { getInterview } from '@/api/interview';

const Memoory = () => {
  const { session } = useAuth();
  const { memooryId } = useParams() as { memooryId: string };

  const { data: interview, isLoading } = useQuery({
    queryKey: ['interview', memooryId],
    queryFn: () => getInterview(memooryId),
    staleTime: Infinity,
  });

  const account = session?.account;

  const isAdmin =
    account && account.status === 'verified' && account?.roles.includes('admin');

  const isOwner = interview?.ownerId === account?.id && account?.id !== undefined;

  return (
    <>
      <NavBar>
        {!isLoading && account && (isAdmin || isOwner) && <MemooryNavTabs />}
      </NavBar>
      <div className="flex flex-auto flex-col">
        <div className="mx-auto flex w-full max-w-screen-xl flex-auto flex-col">
          <Outlet />
        </div>
      </div>

      <Footer />
    </>
  );
};

export const topicsLoader = async () => {
  await queryClient.prefetchQuery({ queryKey: ['topics'], queryFn: getTopics });
  return queryClient.getQueryData(['topics']);
};

export default Memoory;
